import { render, staticRenderFns } from "./AppFeaturesSection.vue?vue&type=template&id=e2237e14&"
import script from "./AppFeaturesSection.vue?vue&type=script&lang=js&"
export * from "./AppFeaturesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports